// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"98":"12927c98","265":"a37a77a6","297":"f5a83a9e","643":"118b7a67"}[chunkId] + ".chunk.js";
};